<template>
  <div>
    <v-navigation-drawer
      app
      :mini-variant="mini"
      clipped
      dark
      v-model="drawer"
      color="rgb(48, 97, 138)"
    >
      <v-divider></v-divider>
      <div class="mt-4 mb-4">
        <v-flex class="center">
          <v-avatar
            :color="`grey lighten-2`"
            elevation="3"
            :size="mini ? 40 : 120"
            align="center"
            justify="center"
          >
            <v-img
              contain
              :src="$store.state.image == null ? logoReady : $store.state.image"
            >
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-icon
                    v-if="logoReady"
                    class="mx-auto"
                    :size="mini ? 40 : 120"
                    >mdi-home-city</v-icon
                  >
                </v-row>
              </template>
            </v-img>
          </v-avatar>
        </v-flex>
        <v-list-item color="rgba(0, 0, 0, .4)" v-if="!mini" class="center" dark>
          <v-list-item-content>
            <v-list-item-title class="mt-2 subtitle-1"
              >{{ $store.state.firstName }}
              {{ $store.state.lastName }}</v-list-item-title
            >
            <v-list-item-title class="subtitle-2 font-weight-light">{{
              $store.state.email
            }}</v-list-item-title>
            <!-- <v-list-item-title class="mt-2">{{companyEmailContact}}</v-list-item-title> -->
          </v-list-item-content>
        </v-list-item>
      </div>

      <v-divider></v-divider>

      <!-- <v-list>
        <v-list-item v-for="item in sidebarMenus" :key="item.title" :to="item.to">
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <span>{{ item.title }}</span>
          </v-list-item-content>
        </v-list-item>
      </v-list>-->
      <v-list v-if="$store.state.permission.adminCompany">
        <v-list-item link :to="{ path: '/dashboard' }">
          <v-list-item-icon>
            <v-icon>mdi-home</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <span class="subtitle-1 font-weight-light">{{
              $vuetify.lang.t('$vuetify.defaultLayout.sidebar.home')
            }}</span>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <!-- รายงานการเงิน -->
      <!-- <v-list v-if="$store.state.permission.adminCompany">
        <v-list-item link :to="{ path: '/dashboard' }">
          <v-list-item-icon>
            <v-icon>mdi-home</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <span class="subtitle-1 font-weight-light">{{
              $vuetify.lang.t("$vuetify.defaultLayout.sidebar.home")
            }}</span>
          </v-list-item-content>
        </v-list-item>
      </v-list> -->

      <!-- <v-list v-if="$store.state.permission.viewStudent">
        <v-list-group
          v-for="item in sidebarMenus"
          v-model="accountManagementActive"
          @click="accountDataManagementOnClick"
          :key="item.title"
          :to="item.to"
        >
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <span class="subtitle-1 font-weight-light">{{ item.title }}</span>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="subItem in item.items"
            :key="subItem.title"
            :to="subItem.to"
          >
            <v-list-item-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <span class="subtitle-1 font-weight-light">{{
                subItem.title
              }}</span>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
        </v-list-group>
      </v-list> -->

      <v-list
        v-if="
          $store.state.permission.insertStudent ||
          $store.state.permission.adminCompany
        "
      >
        <v-list-item link :to="{ path: '/users' }">
          <v-list-item-icon>
            <v-icon>mdi-account-group</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <span class="subtitle-1 font-weight-light">
              <span slot="default">{{
                $vuetify.lang.t(
                  '$vuetify.defaultLayout.sidebar.accountManagement'
                )
              }}</span>
            </span>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-list>
        <v-list-item link :to="{ path: '/course' }">
          <v-list-item-icon>
            <v-icon>mdi-theater</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <span class="subtitle-1 font-weight-light">
              <v-badge
                :offset-x="-2"
                :color="$store.state.totalRequest != 0 ? 'red' : 'transparent'"
              >
                <span v-if="$store.state.totalRequest != 0" slot="badge">{{
                  $store.state.totalRequest
                }}</span>
                <span slot="default">{{
                  $vuetify.lang.t('$vuetify.defaultLayout.sidebar.myCourse')
                }}</span>
              </v-badge>
            </span>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <!-- <v-list>
        <v-list-item link :to="{path: '/course-related'}">
          <v-list-item-icon>
            <v-icon>mdi-checkbox-multiple-blank-outline</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <span
              class="subtitle-1 font-weight-light"
            >{{$vuetify.lang.t("$vuetify.defaultLayout.sidebar.relatedCourse")}}</span>
          </v-list-item-content>
        </v-list-item>
      </v-list>-->

      <!-- <v-list>
        <v-list-item link :to="{path: '/report'}">
          <v-list-item-icon>
            <v-icon class="pl-2">mdi-chart-bar</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <span class="subtitle-1 font-weight-light">{{$vuetify.lang.t("$vuetify.defaultLayout.sidebar.reportCourse")}}</span>
          </v-list-item-content>
        </v-list-item>
      </v-list>-->

      <v-list
        v-if="
          $store.state.permission.viewUserGroup ||
          $store.state.permission.adminCompany
        "
      >
        <v-list-item link :to="{ path: '/user-group' }">
          <v-list-item-icon>
            <v-icon>mdi-account-network-outline</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <span class="subtitle-1 font-weight-light">{{
              $vuetify.lang.t('$vuetify.defaultLayout.sidebar.usergroup')
            }}</span>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-list
        v-if="
          $store.state.permission.viewBanner ||
          $store.state.permission.adminCompany
        "
      >
        <v-list-item link :to="{ path: '/banner' }">
          <v-list-item-icon>
            <v-icon>mdi-checkbook</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <span class="subtitle-1 font-weight-light">{{
              $vuetify.lang.t('$vuetify.defaultLayout.sidebar.banner')
            }}</span>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <!-- <v-list v-if="$store.state.permission.viewCategory">
        <v-list-item link :to="{path: '/category'}">
          <v-list-item-icon>
            <v-icon class="pl-2">mdi-shape-outline</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <span class="subtitle-1 font-weight-light">{{$vuetify.lang.t("$vuetify.defaultLayout.sidebar.categoryManagement")}}</span>
          </v-list-item-content>
        </v-list-item>
      </v-list>-->

      <v-list
        v-if="
          $store.state.permission.viewCategory ||
          $store.state.permission.adminCompany
        "
      >
        <v-list-group
          v-for="item in dataManagementMenus"
          v-model="dataManagementActive"
          @click="accountDataManagementOnClick"
          :key="item.title"
          :to="item.to"
        >
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <span class="subtitle-1 font-weight-light">{{ item.title }}</span>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="subItem in item.items"
            :key="subItem.title"
            :to="subItem.to"
          >
            <v-list-item-icon></v-list-item-icon>
            <v-list-item-content>
              <span class="subtitle-1 font-weight-light">{{
                subItem.title
              }}</span>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
        </v-list-group>
      </v-list>

      <v-list
        v-if="
          ($store.state.permission.notification &&
            $store.state.permission.adminCompany) ||
          $store.state.permission.superAdmin
        "
      >
        <v-list-item link :to="{ path: '/notification' }">
          <v-list-item-icon>
            <v-icon>mdi-calendar-check</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <span class="subtitle-1 font-weight-light">{{
              $vuetify.lang.t('$vuetify.defaultLayout.sidebar.event')
            }}</span>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <!-- <v-list v-if="$store.state.permission.superAdmin">
        <v-list-item link :to="{ path: '/company' }">
          <v-list-item-icon>
            <v-icon>mdi-home-city-outline</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <span class="subtitle-1 font-weight-light">{{
              $vuetify.lang.t(
                '$vuetify.defaultLayout.sidebar.companyManagement'
              )
            }}</span>
          </v-list-item-content>
        </v-list-item>
      </v-list> -->
      <v-list v-if="$store.state.permission.adminCompany">
        <template v-if="isShowKCTTP">
          <v-list-item link :to="{ path: '/report-kct' }">
            <v-list-item-icon>
              <v-icon class="mdi-rotate-45">mdi-chart-pie</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <span class="subtitle-1 font-weight-light"
                >KCT - Transformative Personality</span
              >
            </v-list-item-content>
          </v-list-item>
        </template>
        <v-list-item link :to="{ path: '/companySetting' }">
          <v-list-item-icon>
            <v-icon>mdi-home-edit-outline</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <span class="subtitle-1 font-weight-light">{{
              $vuetify.lang.t('$vuetify.defaultLayout.sidebar.companySetting')
            }}</span>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-list>
        <v-list-item @click="openManual">
          <v-list-item-icon>
            <v-icon>mdi-book-open-variant</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <span class="subtitle-1 font-weight-light">{{
              $vuetify.lang.t('$vuetify.defaultLayout.sidebar.manual')
            }}</span>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar dense app clipped-left flat color="white" elevation="2">
      <v-app-bar-nav-icon
        v-if="!isResponsive"
        @click="appBarIconMiniOnClick"
      ></v-app-bar-nav-icon>
      <v-app-bar-nav-icon
        v-if="isResponsive"
        @click="appBarIconDrawerOnClick"
      ></v-app-bar-nav-icon>

      <v-toolbar-title class="text-uppercase">
        <span>{{ $store.state.title }}</span>
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn
            class="d-flex align-center black--text"
            outlined
            dark
            text
            v-on="on"
          >
            <!-- <v-icon color="black">account_circle</v-icon> -->
            <v-list-item-avatar size="20">
              <img :src="$store.state.image" />
            </v-list-item-avatar>
            <div>{{ $store.state.displayName }}</div>
          </v-btn>
          <div class="text-center language">
            <v-menu open-on-hover offset-y>
              <template v-slot:activator="{ on }">
                <v-btn
                  class="d-flex align-center mr-3"
                  outlined
                  dark
                  text
                  v-on="on"
                >
                  <v-img
                    class="shrink mr-1"
                    contain
                    :src="src"
                    transition="scale-transition"
                    width="20"
                  />

                  <span class="font-italic black--text font-weight-thin">{{
                    currentlanguage
                  }}</span>
                  <!-- <span class="hidden sm:block ml-2">{{ getCurrentLocaleData.lang }}</span> -->
                </v-btn>
              </template>
              <v-list v-model="currentLocale">
                <v-list-item @click="changeLocale('th')">
                  <v-img
                    class="shrink mr-1"
                    width="20"
                    src="@/assets/layout/th.png"
                    alt="th"
                  />
                  <span :style="{ color: $store.state.themeColor }"
                    >&nbsp;Thailand</span
                  >
                </v-list-item>
                <v-list-item @click="changeLocale('en')">
                  <v-img
                    class="shrink mr-1"
                    width="20"
                    src="@/assets/layout/en.png"
                    alt="en"
                  />
                  <span :style="{ color: $store.state.themeColor }"
                    >&nbsp;English</span
                  >
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
        <v-list max-width="300" dark>
          <div>
            <v-list-item color="rgba(0, 0, 0, .4)" class="center" dark>
              <v-list-item-content>
                <div class="center">
                  <v-avatar :size="60" align="center" justify="center">
                    <img :src="$store.state.image" />
                  </v-avatar>
                </div>

                <v-list-item-title class="mt-2 mb-2">{{
                  $store.state.firstName + ' ' + $store.state.lastName
                }}</v-list-item-title>
                <v-list-item-subtitle>{{
                  $store.state.email
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </div>
          <v-divider></v-divider>

          <v-list>
            <v-list-item link @click="onClickProfile">
              <v-list-item-icon>
                <v-icon>mdi-account-edit-outline</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>{{
                  $vuetify.lang.t('$vuetify.defaultLayout.profile')
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item v-model="currentLocale" @click="onLogout">
              <v-list-item-icon>
                <v-icon>mdi-logout-variant</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{
                  $vuetify.lang.t('$vuetify.defaultLayout.logout')
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>

          <!-- <v-list-item-group v-model="currentLocale">
            <v-list-item>
              <v-list-item-content :style="{ color: $store.state.themeColor}">
                <span class="text-center">{{$vuetify.lang.t('$vuetify.defaultLayout.logout')}}</span>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>-->
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-content class="content-container ma-0">
      <transition name="fade">
        <router-view></router-view>
      </transition>
    </v-content>

    <v-dialog v-model="dialogFormUser" scrollable persistent max-width="800px">
      <v-card>
        <v-toolbar flat dark color="primary">
          <v-toolbar-title>
            <v-icon left>mdi-account-edit-outline</v-icon>
            {{ $vuetify.lang.t('$vuetify.defaultLayout.editProfile') }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="onCloseEditProfile">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pr-5 pl-5 pb-0">
          <v-form
            ref="form"
            v-model="valid"
            v-on:submit.prevent="validate"
            id="form"
          >
            <v-container>
              <v-row>
                <v-col class="pb-0" cols="12" sm="6" md="6">
                  <div class="img-padding">
                    <v-avatar
                      :color="`grey lighten-2`"
                      elevation="3"
                      size="200"
                    >
                      <v-img :src="imgPreview" aspect-ratio="1">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height ma-0"
                            align="center"
                            justify="center"
                          >
                            <!-- <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular> -->
                            <v-icon
                              v-if="!imageReady"
                              class="mx-auto"
                              width="240px"
                              height="240px"
                              elevation="3"
                              size="200"
                              color="white"
                              >mdi-account-circle</v-icon
                            >
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>
                  </div>
                  <v-col class="font-weight-light pl-5 pb-0">
                    <v-row class="mb-3 subtitle-1 font-weight-light">{{
                      $vuetify.lang.t(
                        '$vuetify.learnerManagement.learnerList.profileImage'
                      )
                    }}</v-row>
                    <v-row class="mb-2">
                      <div>
                        <v-file-input
                          class="
                            subtitle-2
                            font-weight-light
                            upload-image-button
                            my-0
                            py-0
                            pl-5
                          "
                          v-model="imageFile"
                          @change="preview"
                          light
                          clearable
                          clear-icon="mdi-close mb-2"
                          solo
                          dense
                          flat
                          prepend-icon="mdi-upload"
                          accept="image/png, image/jpeg, image/bmp"
                          :placeholder="
                            $vuetify.lang.t(
                              '$vuetify.learnerManagement.learnerList.upload'
                            )
                          "
                        ></v-file-input>
                      </div>
                      <!-- </v-btn> -->
                    </v-row>
                    <v-row
                      >{{
                        $vuetify.lang.t(
                          '$vuetify.learnerManagement.learnerList.acceptableFormats'
                        )
                      }}: .png .jpg</v-row
                    >
                    <v-row>{{
                      $vuetify.lang.t(
                        '$vuetify.learnerManagement.learnerList.maxFileSize'
                      )
                    }}</v-row>
                    <v-row>
                      <v-col class="pl-0 pt-10 pb-0" cols="12">
                        <p class="mb-2">
                          {{ $vuetify.lang.t('$vuetify.defaultLayout.email') }}
                          <span class="red--text">*</span>
                        </p>
                        <v-text-field
                          outlined
                          :rules="emailRules"
                          clearable
                          :placeholder="
                            $vuetify.lang.t('$vuetify.defaultLayout.email')
                          "
                          v-model="email"
                          class="icon-text-input"
                        ></v-text-field>
                      </v-col>
                      <v-col class="pl-0 pt-6" cols="12">
                        <v-checkbox
                          v-model="checkboxPassword"
                          @change="onCheckPassword"
                          :label="
                            $vuetify.lang.t(
                              '$vuetify.learnerManagement.learnerList.updatePassword'
                            )
                          "
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-col>
                  <!-- <p>
                    {{ $vuetify.lang.t('$vuetify.defaultLayout.uploadPhoto') }}
                  </p> -->
                  <!-- <v-file-input
                    v-model="imageFile"
                    @change="preview"
                    outlined
                    dense
                    show-size
                    accept="image/png, image/jpeg, image/bmp"
                    :label="
                      imgPreview
                        ? $vuetify.lang.t(
                            '$vuetify.defaultLayout.chooseNewPhoto'
                          )
                        : $vuetify.lang.t('$vuetify.defaultLayout.choosePhoto')
                    "
                    prepend-icon="mdi-camera"
                  ></v-file-input> -->
                </v-col>
                <v-col class="pb-0" cols="12" sm="6" md="6">
                  <p class="mb-2">
                    {{ $vuetify.lang.t('$vuetify.defaultLayout.firstName') }}
                    <span class="red--text">*</span>
                  </p>
                  <v-text-field
                    outlined
                    :rules="firstNameRules"
                    clearable
                    :placeholder="
                      $vuetify.lang.t('$vuetify.defaultLayout.firstName')
                    "
                    v-model="firstName"
                    class="icon-text-input"
                  ></v-text-field>
                  <p class="mb-2">
                    {{ $vuetify.lang.t('$vuetify.defaultLayout.lastName') }}
                    <span class="red--text">*</span>
                  </p>
                  <v-text-field
                    outlined
                    :rules="lastNameRules"
                    clearable
                    :placeholder="
                      $vuetify.lang.t('$vuetify.defaultLayout.lastName')
                    "
                    v-model="lastName"
                    class="icon-text-input"
                  ></v-text-field>
                  <p class="mb-2">
                    {{ $vuetify.lang.t('$vuetify.defaultLayout.gender') }}
                    <span class="red--text">*</span>
                  </p>
                  <v-autocomplete
                    v-model="selectedGender"
                    :items="genders"
                    item-text="text"
                    item-value="value"
                    outlined
                    :placeholder="
                      $vuetify.lang.t('$vuetify.defaultLayout.gender')
                    "
                    class="icon-autocomplete"
                  ></v-autocomplete>
                  <p class="mb-2">
                    {{ $vuetify.lang.t('$vuetify.defaultLayout.organization') }}
                  </p>
                  <v-text-field
                    outlined
                    clearable
                    :placeholder="
                      $vuetify.lang.t('$vuetify.defaultLayout.organization')
                    "
                    v-model="school"
                    class="icon-text-input"
                  ></v-text-field>
                  <p class="mb-2">
                    {{
                      $vuetify.lang.t(
                        '$vuetify.instructorManagement.instructorList.description'
                      )
                    }}
                  </p>
                  <v-textarea
                    no-resize
                    outlined
                    v-model="description"
                  ></v-textarea>
                </v-col>

                <v-col cols="12" class="pl-5 py-0" v-if="checkboxPassword">
                  <v-row>
                    <v-col
                      class="pl-5 pr-8 pb-0"
                      cols="12"
                      :xl="6"
                      :lg="6"
                      :md="6"
                      :sm="12"
                    >
                      <p class="mb-2">
                        {{ $vuetify.lang.t('$vuetify.defaultLayout.username') }}
                      </p>
                      <div class="pt-1">
                        <span class="body-1"
                          ><b>{{ username }} </b></span
                        >
                      </div>
                      <!-- <v-text-field
                          outlined
                          clearable
                          :placeholder="
                            $vuetify.lang.t('$vuetify.defaultLayout.username')
                          "
                          disabled
                          v-model="username"
                        ></v-text-field> -->
                    </v-col>
                    <v-col
                      class="pl-0 pb-0"
                      cols="12"
                      :xl="6"
                      :lg="6"
                      :md="6"
                      :sm="12"
                    >
                      <p class="mb-2">
                        {{ $vuetify.lang.t('$vuetify.defaultLayout.oldPass') }}
                        <span v-if="checkboxPassword" class="red--text">*</span>
                      </p>
                      <v-text-field
                        :type="showOldPassword ? 'text' : 'password'"
                        outlined
                        clearable
                        :placeholder="
                          $vuetify.lang.t('$vuetify.defaultLayout.oldPass')
                        "
                        :disabled="!checkboxPassword"
                        :rules="passwordRules"
                        v-model="oldPassword"
                        :append-icon="
                          !showOldPassword ? 'mdi-eye' : 'mdi-eye-off'
                        "
                        @click:append="showOldPassword = !showOldPassword"
                        class="icon-text-input"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      class="pl-5 pr-8 pt-0"
                      cols="12"
                      :xl="6"
                      :lg="6"
                      :md="6"
                      :sm="12"
                    >
                      <p class="mb-2">
                        {{ $vuetify.lang.t('$vuetify.defaultLayout.newPass') }}
                        <span v-if="checkboxPassword" class="red--text">*</span>
                      </p>
                      <v-text-field
                        :type="showNewPassword ? 'text' : 'password'"
                        outlined
                        clearable
                        :rules="passwordRules"
                        :placeholder="
                          $vuetify.lang.t('$vuetify.defaultLayout.newPass')
                        "
                        :disabled="!checkboxPassword"
                        v-model="newPassword"
                        :append-icon="
                          !showNewPassword ? 'mdi-eye' : 'mdi-eye-off'
                        "
                        @click:append="showNewPassword = !showNewPassword"
                        class="icon-text-input"
                      ></v-text-field>
                    </v-col>

                    <v-col
                      class="pl-0 pt-0"
                      cols="12"
                      :xl="6"
                      :lg="6"
                      :md="6"
                      :sm="12"
                      ><p class="mb-2">
                        {{
                          $vuetify.lang.t('$vuetify.defaultLayout.confirmPass')
                        }}
                        <span v-if="checkboxPassword" class="red--text">*</span>
                      </p>
                      <v-text-field
                        :type="showConfirmPassword ? 'text' : 'password'"
                        outlined
                        id="confirm-password"
                        clearable
                        :rules="conFirmPasswordRules"
                        :disabled="!checkboxPassword"
                        :placeholder="
                          $vuetify.lang.t('$vuetify.defaultLayout.confirmPass')
                        "
                        v-model="confirmPassword"
                        :append-icon="
                          !showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'
                        "
                        @click:append="
                          showConfirmPassword = !showConfirmPassword
                        "
                        class="icon-text-input"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
          <!-- <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="grey" dark  outlined @click="dialog = false">ยกเลิก</v-btn>
                <v-btn color="primary"  :disabled="!valid" @click="validate">บันทึก</v-btn>
          </v-card-actions>-->
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" dark outlined @click="onCloseEditProfile">{{
            $vuetify.lang.t('$vuetify.defaultLayout.cancel')
          }}</v-btn>
          <v-btn color="primary" :disabled="!valid" @click="validate">{{
            $vuetify.lang.t('$vuetify.defaultLayout.save')
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogEditSuccess" max-width="450">
      <v-card>
        <v-card-title class="headline">{{
          $vuetify.lang.t('$vuetify.defaultLayout.editingUserSucceeded')
        }}</v-card-title>

        <v-card-text>{{
          $vuetify.lang.t('$vuetify.defaultLayout.userInformationUpdated')
        }}</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="onCloseEditProfileSuccess"
            >{{ $vuetify.lang.t('$vuetify.defaultLayout.completed') }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogEditFail" max-width="450">
      <v-card>
        <v-card-title class="headline">แก้ไขผู้ใช้งานไม่สำเร็จ</v-card-title>

        <v-card-text
          >เกิดข้อผิดพลาดในการเพิ่มข้อมูล กรุณาลองใหม่อีกครั้ง</v-card-text
        >

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="error darken-1" text @click="dialogEditFail = false">{{
            $vuetify.lang.t('$vuetify.defaultLayout.ok')
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogUsernameDuplicade" max-width="450">
      <v-card>
        <v-card-title class="headline">บันทึกไม่สำเร็จ</v-card-title>

        <v-card-text
          >อีเมล หรือชื่อผู้ใช้นี้ได้ถูกใช้ไปแล้ว กรุณาใช้ชื่ออื่น</v-card-text
        >

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="primary darken-1"
            text
            @click="dialogUsernameDuplicade = false"
            >{{ $vuetify.lang.t('$vuetify.defaultLayout.ok') }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar"
      :dark="snackbarOptions.dark || false"
      :color="snackbarOptions.color"
      :top="snackbarOptions.top || false"
      :centered="snackbarOptions.centered || false"
      :timeout="snackbarOptions.timeout || 5000"
    >
      <div v-html="snackbarOptions.text"></div>

      <template v-slot:action="{ attrs }">
        <v-btn
          icon
          v-bind="attrs"
          @click="snackbar = false"
          :dark="snackbarOptions.dark || false"
        >
          <v-icon small>mdi-close-circle</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { EventBus } from '../event-bus';
import { editProfile, updatePassword } from '../service/account/manageUser';
import { getInfo, logout } from '../service/account/login';
import { uploadImage } from '../service/upload/upload';
import KCTService from '../views/kct-transformative-personality/service';
import { getCreditPoint } from '../service/company/company';
import numeral from 'numeral';

export default Vue.extend({
  data: function () {
    return {
      snackbar: false,
      snackbarOptions: {},
      admins: [
        ['Management', 'people_outline'],
        ['Settings', 'settings'],
      ],
      src: '',
      logoReady: true,
      userInfo: {},
      companyName: '',
      userName: '',
      picture: '',
      isResponsive: false,
      drawer: false,
      mini: false,
      currentLocale: 0,
      languages: [
        {
          title: 'en',
          img: require('../assets/layout/en.png'),
        },
        {
          title: 'th',
          img: require('../assets/layout/th.png'),
        },
      ],
      // currentlanguage: 'en',
      currentlanguage: 'th',

      // Profile
      valid: true,
      dialogFormUser: false,
      checkboxPassword: false,
      scrollBottom: false,
      showOldPassword: false,
      showNewPassword: false,
      showConfirmPassword: false,

      firstName: '',
      lastName: '',
      selectedGender: null,
      email: '',
      school: '',
      username: '',
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
      description: '',

      imgURL: '',
      imgPreview: '',
      imageFile: null,
      imageReady: false,
      accountManagementActive: false,
      dataManagementActive: false,

      companyEmailContact: '',

      // companyEmailContact: this.$store.state.company.contactEmail,

      genders: [
        {
          text: this.$vuetify.lang.t('$vuetify.defaultLayout.male'),
          // text: "หญิง",
          value: 'male',
        },
        {
          text: this.$vuetify.lang.t('$vuetify.defaultLayout.female'),
          // text: "ชาย",
          value: 'female',
        },
        {
          text: this.$vuetify.lang.t('$vuetify.defaultLayout.unknown'),
          // text: "ไม่ระบุ",
          value: null,
        },
      ],

      dialogEditSuccess: false,
      dialogEditFail: false,
      dialogUsernameDuplicade: false,

      imageRules: [
        // v => !!v || this.$vuetify.lang.t("$vuetify.plsUploadPhoto"),
        (v) =>
          v.size < 20000000 ||
          this.$vuetify.lang.t('$vuetify.plsChooseUnder20MB'),
      ],
      nameRules: [
        (v) => !!v || this.$vuetify.lang.t('$vuetify.plsEnterAllData'),
      ],
      firstNameRules: [
        (v) =>
          !!v || this.$vuetify.lang.t('$vuetify.defaultLayout.enterFirstname'),
      ],
      lastNameRules: [
        (v) =>
          !!v || this.$vuetify.lang.t('$vuetify.defaultLayout.enterLastname'),
      ],
      genderRules: [
        (v) =>
          !!v || this.$vuetify.lang.t('$vuetify.defaultLayout.enterGender'),
      ],
      userNameRules: [
        (v) =>
          !!v || this.$vuetify.lang.t('$vuetify.defaultLayout.enterUsername'),
      ],

      emailRules: [
        (v) => !!v || this.$vuetify.lang.t('$vuetify.defaultLayout.enterEmail'),
        (v) => /.+@.+\..+/.test(v) || 'กรุณากรอกให้อยู่ในรูปแบบอีเมล',
      ],
      isShowKCTTP: false,
    };
  },
  computed: {
    sidebarMenus() {
      return [
        // {
        //   title: this.$vuetify.lang.t(
        //     "$vuetify.defaultLayout.sidebar.dashboard"
        //   ),
        //   icon: "mdi-home",
        //   to: { path: "/dashboard" }
        // },
        // {
        //   title: this.$vuetify.lang.t("$vuetify.defaultLayout.sidebar.user"),
        //   icon: "mdi-account-outline",
        //   to: { path: "/users" }
        // },
        {
          title: this.$vuetify.lang.t(
            '$vuetify.defaultLayout.sidebar.accountManagement'
          ),
          icon: 'mdi-account-group',
          to: {
            path: '/account',
          },

          items: [
            {
              title: this.$vuetify.lang.t(
                '$vuetify.defaultLayout.sidebar.user'
              ),
              icon: 'mdi-account-outline',
              to: {
                path: '/users',
              },
            },
            {
              title: this.$vuetify.lang.t(
                '$vuetify.defaultLayout.sidebar.instructor'
              ),
              icon: 'mdi-account-tie-outline',
              to: {
                path: '/account',
              },
            },
            // {
            //   title: this.$vuetify.lang.t(
            //     "$vuetify.defaultLayout.sidebar.instructorRegistration"
            //   ),
            //   icon: "mdi-account-tie-outline",
            //   to: { path: "/registration" }
            // }
          ],
        },

        // {
        //   title: this.$vuetify.lang.t(
        //     "$vuetify.defaultLayout.sidebar.confirmTutor"
        //   ),
        //   icon: "mdi-file-document-edit",
        //   to: { path: "/confirmtutor" }
        // },

        // {
        //   title: this.$vuetify.lang.t("$vuetify.defaultLayout.sidebar.report"),
        //   icon: "mdi-chart-bar",
        //   to: { path: "/report" }
        // }
      ];
    },
    dataManagementMenus() {
      return [
        {
          title: this.$vuetify.lang.t(
            '$vuetify.defaultLayout.sidebar.categoryManagement'
          ),
          icon: 'mdi-shape-outline',
          to: {
            path: '/category',
          },

          items: [
            {
              title: this.$vuetify.lang.t(
                '$vuetify.defaultLayout.sidebar.category'
              ),
              to: {
                path: '/category',
              },
            },
            {
              title: this.$vuetify.lang.t(
                '$vuetify.defaultLayout.sidebar.skill'
              ),
              to: {
                path: '/skill',
              },
            },
            // {
            //   title: this.$vuetify.lang.t(
            //     '$vuetify.defaultLayout.sidebar.level'
            //   ),
            //   to: {
            //     path: '/level',
            //   },
            // },
          ],
        },
      ];
    },
    passwordRules() {
      const rules = [];

      if (this.checkboxPassword == true) {
        rules.push(
          (v) =>
            v.length >= 8 ||
            this.$vuetify.lang.t('$vuetify.defaultLayout.least8characters')
        );
      }

      return rules;
    },
    conFirmPasswordRules() {
      const rules = [];
      if (this.checkboxPassword == true) {
        rules.push(
          (v) =>
            (!!v && v) === this.newPassword ||
            this.$vuetify.lang.t('$vuetify.defaultLayout.matchedPassword')
        );
        rules.push(
          (v) =>
            v.length >= 8 ||
            this.$vuetify.lang.t('$vuetify.defaultLayout.least8characters')
        );
      }
      return rules;
    },
  },
  updated() {
    if (this.$vuetify.lang.current === 'en') this.currentLocale = 0;
    else this.currentLocale = 1;

    if (this.$vuetify.breakpoint.lgAndUp) {
      this.drawer = true;
      this.isResponsive = false;
    } else {
      this.isResponsive = true;
    }
  },
  created() {
    EventBus.$on('snackbar', (params) => {
      this.snackbarHandler(params);
    });
    EventBus.$on('creditPoint.show', () => {
      this.showCreditPoint();
    });
  },
  beforeDestroy() {
    EventBus.$off('snackbar');
    EventBus.$off('creditPoint.show');
  },
  mounted() {
    this.companyEmailContact = this.$store.state.company.contactEmail;

    if (this.$vuetify.breakpoint.lgAndUp) {
      this.drawer = true;
      this.isResponsive = false;
    } else {
      this.isResponsive = true;
    }
    this.currentLocale == 0
      ? (this.src = require('@/assets/layout/th.png'))
      : (this.src = require('@/assets/layout/en.png'));

    KCTService.checkCompany().then((val) => {
      this.isShowKCTTP = val;
    });
  },
  watch: {
    snackbar(val) {
      if (!val) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.snackbarOptions = {};
          }, 1000);
        });
      }
    },
  },
  methods: {
    showCreditPoint() {
      const company = this.$store.state.company;
      if (company != null) {
        let isEnterpriseOrg = false;

        if (company.created_by != null && company.created_by.length > 0) {
          isEnterpriseOrg = false;
        } else {
          isEnterpriseOrg = true;
        }

        if (isEnterpriseOrg == true) {
          // do nothing if this is enterprise org
          // console.log('enterprise org not show credit point');
          return;
        }

        getCreditPoint({})
          .then((resp) => {
            let point = numeral(resp.point || 0).format('0,0.00');

            this.snackbarHandler({
              text: `Your credit point is left: <span class='font-weight-bold'>${point}</span>`,
              dark: true,
              centered: true,
              color: 'success',
              timeout: 10 * 1000,
            });
          })
          .catch((err) => {
            // do nothing
          });
      } else {
        // do nothing
      }
    },
    snackbarHandler(params) {
      const { text, dark, color, centered, top, timeout } = params;
      this.snackbarOptions.text = text || '-';
      this.snackbarOptions.dark = dark || false;
      this.snackbarOptions.color = color;
      this.snackbarOptions.centered = centered || false;
      this.snackbarOptions.top = top || false;
      this.snackbarOptions.timeout = timeout || 5000;

      this.snackbar = true;
    },
    onCheckPassword() {
      let firstElement = document.getElementById('form');
      let lastElement = document.getElementById('confirm-password');

      if (this.scrollBottom) {
        firstElement.scrollIntoView({
          behavior: 'smooth',
        });
      } else {
        lastElement.scrollIntoView({
          behavior: 'smooth',
        });
      }

      this.scrollBottom = !this.scrollBottom;
    },
    onClickProfile() {
      this.dialogFormUser = true;

      this.firstName = this.$store.state.firstName;
      this.lastName = this.$store.state.lastName;
      this.email = this.$store.state.email;
      this.school = this.$store.state.school;
      this.username = this.$store.state.username;
      this.imgPreview = this.$store.state.image;
      this.imgURL = this.$store.state.image;
      this.description = this.$store.state.description;
      if (this.description !== null || this.description !== '') {
        this.description = this.description.toString();
        this.description = this.description.replace(/(<([^>]+)>)/gi, '');
      }
      this.selectedGender = this.genders.filter(
        (gender) => gender.value == this.$store.state.gender
      )[0].value;
    },
    async onLogout() {
      await logout();
      await this.$store.commit('clear');
      await localStorage.clear();
      await this.$router.replace({
        path: '/login',
      });
    },
    async validate() {
      if (this.$refs.form.validate()) {
        if (this.imgPreview) {
          this.preview();
        }
        let status = await editProfile({
          username: this.username,
          firstName: this.firstName,
          lastName: this.lastName,
          school: this.school,
          studentCode: '',
          email: this.email,
          gender: this.selectedGender,
          image: this.imgPreview,
          description: this.description,
          identificationNumber: '',
        });
        if (status.message == 'username or email duplicade') {
          this.dialogUsernameDuplicade = true; //กรณีชื่อซ้ำ
          return;
        } else if (status.code) {
          this.dialogEditFail = true; //กรณี error อื่น
          return;
        }

        if (this.checkboxPassword) {
          let updatePasswordResult = await updatePassword({
            passwordold: this.oldPassword,
            passwordnew: this.newPassword,
          });
          updatePasswordResult.code !== 403
            ? localStorage.setItem(
                'x-session-token',
                updatePasswordResult.token
              )
            : null;
          if (updatePasswordResult.code == 403) {
            this.dialogEditFail = true; //กรณี error อื่น
            return;
          }
        }
        this.dialogEditSuccess = true;
        let resultInfo = await getInfo();
        await this.$store.commit('setTheme', resultInfo.info);
      } else {
        console.log('not pass');
      }
    },
    async uploadImg(image) {
      let status = await uploadImage('user', image);
      return status;
    },
    async preview() {
      if (this.imageFile != null) {
        this.imgURL = await this.uploadImg(this.imageFile);
        this.imgPreview = this.imgURL;
        this.imageReady = true;
      } else {
        this.imageReady = false;
      }
    },
    changeLocale(locale) {
      this.src =
        locale === 'th'
          ? require('@/assets/layout/th.png')
          : require('@/assets/layout/en.png');
      this.currentlanguage = locale;
      EventBus.$emit('change-locale', locale);
    },

    onCloseEditProfile() {
      this.dialogFormUser = false;
      this.checkboxPassword = false;
      this.oldPassword = '';
      this.newPassword = '';
      this.confirmPassword = '';
      this.showOldPassword = false;
      this.showNewPassword = false;
      this.showConfirmPassword = false;
    },

    onCloseEditProfileSuccess() {
      this.dialogEditSuccess = false;
      this.onCloseEditProfile();
    },
    // signout() {

    // }

    appBarIconDrawerOnClick() {
      this.drawer = !this.drawer;
      this.accountManagementActive = false;
      this.dataManagementActive = false;
    },
    appBarIconMiniOnClick() {
      this.mini = !this.mini;
      this.accountManagementActive = false;
      this.dataManagementActive = false;
    },

    accountDataManagementOnClick() {
      // console.log(this.mini);
      // console.log(this.drawer);
      //if (!this.isResponsive) {
      //  this.mini = false;
      //} else {
      //  this.drawer = false;
      // }
    },
    openManual(){
      let host = window.location.host
      let domain = ""
      if(host.indexOf("vknows")>-1){
        domain = "vknows.co"
      } else if(host.indexOf("clsedo")>-1) {
        domain = "clsedo.com"
      } else if(host.indexOf("nerdof")>-1) {
        domain = "nerdof.com"
      } else {
        domain = "nerdof.com"
      }
      let manualUrl = "https://howto."+domain
      window.open(manualUrl, '_blank')
    }
  },
});
</script>

<style scoped>
.upload-image-button {
  border: 1px solid;
  /* border-radius: 8px; */
  border-color: rgba(65, 65, 65, 0.3);
  height: 40px;
  widows: 400px;
  /* color: rgb(65, 65, 65); */
  border: 1px solid rgb(195, 195, 195);
}
.img-circle {
  border-radius: 50px;
}

.img-padding {
  display: flex;
  align-items: center;
  justify-content: center;
}

.sizeImgCompany {
  position: relative;
  width: 60%;
  height: 60%;
}

.text_green {
  color: green;
}

.font-black {
  color: black;
}

/* .v-application--is-ltr .v-toolbar__content > .v-btn.v-btn--icon:last-child,
.v-application--is-ltr .v-toolbar__extension > .v-btn.v-btn--icon:last-child {
  margin-right: unset;
  float: right;
  width: unset;
} */
.v-list-group
  .v-list-group__header
  .v-list-item__icon.v-list-group__header__append-icon {
  align-self: center;
  margin: 0;
  min-width: 48px;
  justify-content: flex-end;
  display: none;
}

.v-list-item__icon .v-list-group__header__append-icon {
  visibility: hidden;
}

.v-application .v-list-group--active {
  color: white !important;
  caret-color: white !important;
}

.v-list {
  padding: 0 0;
}

.v-list--dense .v-list-item .v-list-item__title {
  line-height: normal;
}

.language {
  /* margin-right: 30px; */
}

.content-container {
  margin: 10px 10px 10px 10px;
}

.center {
  text-align: center;
}
</style>
<style lang="scss">
.icon-text-input {
  .v-input__control > .v-input__slot > .v-input__append-inner {
    margin-top: 5px !important;
  }
}
.icon-autocomplete {
  .v-input__control
    > .v-input__slot
    > .v-select__slot
    > .v-input__append-inner {
    margin-top: 5px !important;
  }
}
</style>